<template>
  <div>
    <v-expansion-panel class="elevation-0">
      <v-expansion-panel-content v-for="group in groups" :key="group._id" class="group-panel">
        <template v-slot:header>
          <div class="group-header">
            <div class="d-flex align-center">
              <v-avatar size="32" class="mr-3 group-avatar">
                <span>{{ getInitials(group.shortName || group.fullName) }}</span>
              </v-avatar>
              <div>
                <div class="group-title">
                  {{ group.fullName || group.shortName }}
                  <v-chip
                    outline
                    label
                    small
                    :color="getTypeColor(group.type)"
                    :text-color="getTypeColor(group.type)"
                    class="ml-3"
                  >
                    {{ group.type ? $t(capitalize(group.type)) : $t("Default") }}
                  </v-chip>
                </div>
                <div class="group-subtitle">
                  <v-icon small class="mr-1">mdi-account-multiple</v-icon>
                  {{ $t("Users") }}: {{ group.users ? group.users.length : 0 }}
                  <span class="mx-2"> - </span>
                  <v-icon small class="mr-1">mdi-account</v-icon>
                  {{ $t("Manager") }} : {{ group.manager ? getUserName(group.manager) : 0 }}
                </div>
              </div>
            </div>
          </div>
        </template>
        <v-card flat>
          <v-card-text class="pa-2">
            <div v-if="group.users && group.users.length > 0">
              <div>
                <v-list-tile
                  v-for="user in group.users"
                  :key="user"
                  avatar
                  :to="isAdmin ? { name: 'User', params: { id: user.userInfo } } : undefined"
                >
                  <v-list-tile-avatar class="mr-3">
                    <img :src="getAvatarUrl(user.userInfo)" />
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ getUserName(user.userInfo) }}
                      <span class="ml-2 role-badge">
                        {{ $t(user.role) }}
                      </span>
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      <a :href="`mailto:${getUserEmail(user.userInfo)}`">{{ getUserEmail(user.userInfo) }}</a>
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title> </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </div>
            </div>
            <div v-else class="text-xs-center grey--text font-italic pa-3">
              {{ $t("No users in this group") }}
            </div>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import { routeNames } from "@/router";
import { USER_TYPE } from "@/constants.js";
import { getUserAvatarUrl } from "@/services/helpers/user";
import GroupDetails from "@/components/group/GroupDetails.vue";
import { GROUP_TYPE_COLOR } from "../../constants";

export default {
  components: {
    GroupDetails
  },
  props: {
    groups: {
      type: Array,
      required: true
    },
    users: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      detailsDialog: false,
      selectedGroup: null
    };
  },
  created() {
    this.$store.dispatch("users/fetchUsers");
  },
  methods: {
    getInitials(name) {
      if (!name) return "?";
      return name
        .split(" ")
        .map(word => word.charAt(0).toUpperCase())
        .join("")
        .substring(0, 2);
    },
    getTypeColor(type) {
      return GROUP_TYPE_COLOR[type] || "grey";
    },
    capitalize(str) {
      if (!str) return "";
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    getUserName(userId) {
      const user = this.users.find(u => u._id === userId || u.user === userId);
      return user ? user.name : userId;
    },
    getUserEmail(userId) {
      const user = this.users.find(u => u._id === userId || u.user === userId);
      return user ? user.email : "";
    },
    getAvatarUrl(userId) {
      return getUserAvatarUrl(userId);
    },
    getUserRole(userId) {
      const user = this.users.find(u => u._id === userId || u.user === userId);

      return user ? user.role : "";
    },
    viewGroupDetails(group) {
      this.selectedGroup = group;
      this.detailsDialog = true;
    }
  },
  computed: {
    isAdmin() {
      return this.$auth.check(USER_TYPE.ADMIN);
    },
    routeNames() {
      return routeNames;
    }
  }
};
</script>

<style scoped>
.group-avatar {
  background-color: #f5f5f5;
  color: #333;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}

.group-panel {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.group-title {
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.group-subtitle {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
}

.user-list {
  max-height: 300px;
  overflow-y: auto;
}

.group-actions {
  display: flex;
  align-items: center;
}

.details-btn {
  margin-left: 8px;
}
.role-badge {
  color: #666;
  font-size: 0.8em;
}
.details-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
